import moment from 'moment';

/**
 * Downloads CSV file with the provided data
 * @param {Array} data - Array of objects to convert to CSV
 * @param {Array} headers - Array of header objects with { label, key } structure
 * @param {String} filename - Name of the file to download (optional, defaults to current date)
 * @returns {void}
 */
export const downloadCSV = (data, headers, filename = null) => {
  // Validate inputs
  if (!Array.isArray(data) || !Array.isArray(headers)) {
    console.error('downloadCSV: data and headers must be arrays');
    return;
  }

  // Generate default filename if not provided
  const finalFilename = filename || `export-${moment().format('MM/DD/YYYY')}.csv`;

  // Create CSV header row
  const headerRow = headers.map(h => h.label).join(',');
  
  // Create CSV data rows
  const dataRows = data.map(item => {
    return headers.map(header => {
      const value = item[header.key];
      // Escape quotes and wrap in quotes if contains comma
      const escapedValue = value && value.toString ? value.toString().replace(/"/g, '""') : '';
      return escapedValue.includes(',') ? `"${escapedValue}"` : escapedValue;
    }).join(',');
  });

  // Combine header and data
  const csv = [headerRow, ...dataRows];
  const csvContent = csv.join('\n');

  // Create blob and download
  const blob = new Blob([csvContent], { type: 'text/csv;charset=utf-8;' });
  const link = document.createElement('a');
  const url = URL.createObjectURL(blob);
  
  link.setAttribute('href', url);
  link.setAttribute('download', finalFilename);
  link.style.visibility = 'hidden';
  
  document.body.appendChild(link);
  link.click();
  document.body.removeChild(link);
  
  // Clean up the object URL
  URL.revokeObjectURL(url);
};

export default downloadCSV;
